import { createContext, useContext } from "react";

interface TabRailContextValue {
  activeTabId: string;
  onSelectTab: (id: string) => void;
}

// Internal wiring only -- not exported from the package barrel. Lets `TabRail.List` read the
// root's selection state without threading it through every part as props.
export const TabRailContext = createContext<TabRailContextValue | null>(null);

export const useTabRailContext = () => {
  const context = useContext(TabRailContext);
  if (!context) throw new Error("TabRail parts must be rendered within <TabRail>.");
  return context;
};
